import { combineReducers } from 'redux';
import {
  GET_ACCELERATED_TESTERS,
  UPDATE_ACCELERATED_TESTER_OVERRIDE,
  UPDATE_ACCELERATED_TESTER_OVERRIDES_BULK,
  UPLOAD_ACCELERATED_TESTERS_FILE,
} from './acceleratedTesters.actions';
import { ASYNC_ERROR, ASYNC_FINISH, ASYNC_START } from '../../common/index';

const loadingMsg = (state = '', action) => {
  switch (action.type) {
    case ASYNC_START:
      if (action.model === GET_ACCELERATED_TESTERS) {
        return 'Loading Accelerated Testers ...';
      }
      return state;
    case ASYNC_ERROR:
    case ASYNC_FINISH:
      if (action.model === GET_ACCELERATED_TESTERS) {
        return '';
      }
      return state;
    default:
      return state;
  }
};

// Optimistically fold the saved override back onto the matching node entry so
// resolved-level columns and header counts update live without a refetch.
const mergeOverride = (entry, override) =>
  Object.assign({}, entry, {
    override: Object.assign({}, entry && entry.override, override),
  });

const acceleratedTesters = (state = {}, action) => {
  switch (action.type) {
    case ASYNC_FINISH:
      if (action.model === GET_ACCELERATED_TESTERS) {
        return action.data.acceleratedTesters || {};
      }
      if (action.model === UPDATE_ACCELERATED_TESTER_OVERRIDE) {
        const { firebaseId, override } = action.data;
        if (!state[firebaseId]) return state;
        return Object.assign({}, state, {
          [firebaseId]: mergeOverride(state[firebaseId], override),
        });
      }
      if (action.model === UPDATE_ACCELERATED_TESTER_OVERRIDES_BULK) {
        const { updates } = action.data;
        const next = Object.assign({}, state);
        Object.entries(updates || {}).forEach(([firebaseId, override]) => {
          if (next[firebaseId]) {
            next[firebaseId] = mergeOverride(next[firebaseId], override);
          }
        });
        return next;
      }
      return state;
    default:
      return state;
  }
};

// Tracks the file-upload lifecycle for the override-page Dropzone. `seq` increments
// on every settled upload so the component can detect a fresh completion (and fire a
// toast) via a prop change, even when the same message repeats.
const initialUpload = { uploading: false, error: null, result: null, seq: 0 };
const upload = (state = initialUpload, action) => {
  switch (action.type) {
    case ASYNC_START:
      if (action.model === UPLOAD_ACCELERATED_TESTERS_FILE) {
        return { uploading: true, error: null, result: null, seq: state.seq };
      }
      return state;
    case ASYNC_FINISH:
      if (action.model === UPLOAD_ACCELERATED_TESTERS_FILE) {
        return {
          uploading: false,
          error: null,
          result: (action.data && action.data.result) || null,
          seq: state.seq + 1,
        };
      }
      return state;
    case ASYNC_ERROR:
      if (action.model === UPLOAD_ACCELERATED_TESTERS_FILE) {
        return {
          uploading: false,
          error: action.desc || 'Upload failed.',
          result: null,
          seq: state.seq + 1,
        };
      }
      return state;
    default:
      return state;
  }
};

export const _reducer = combineReducers({
  loadingMsg,
  acceleratedTesters,
  upload,
});

export default 'acceleratedTesters.reducers.js';
